module.exports = __webpack_public_path__ + "static/media/DSC07978.4cce6539.jpg";